export default __webpack_public_path__ + "static/media/balance-mastercard.f59f1c49.svg";